import React, { createContext, useContext } from 'react';
import type { Router } from '@remix-run/router';
import { RouterProvider as ReactRouterProvider } from 'react-router-dom';

export const AppRouterContext = createContext<Router | null>(null);

type AppRouterProviderProps = {
  router: Router;
};

export const AppRouterProvider = ({ router }: AppRouterProviderProps) => (
  <AppRouterContext.Provider value={router}>
    <ReactRouterProvider router={router} />
  </AppRouterContext.Provider>
);

export const useAppRouter = () => {
  const router = useContext<Router | null>(AppRouterContext);
  if (!router) {
    throw new Error('useAppRouter must be used within an AppRouterProvider');
  }
  return router;
};
